import styled from '@emotion/styled';

const PanelFooter = styled('div')`
  border-top: 1px solid ${p => p.theme.borderDark};
  color: ${p => p.theme.gray3};
  font-size: 14px;
`;

export default PanelFooter;
